import * as React from 'react';
import ColorScheme, { colorSchemeToCss } from 'owa-color-utils/lib/ColorScheme';
import { IButtonProps, IconButton } from '@fluentui/react/lib/Button';
import { observer } from 'mobx-react-lite';
import { isFeatureEnabled } from 'owa-feature-flags';
import { isHostAppFeatureEnabled } from 'owa-hostapp-feature-flags';

let styles = require('./CalendarBar.scss');
let classNames = require('classnames/bind').bind(styles);

export interface CalendarBarProps extends React.HTMLProps<HTMLDivElement> {
    calendarColorScheme: ColorScheme;
    schedulingAssistantHeader?: string;
    buttonProps?: IButtonProps[];
}

const CalendarBar = observer(function CalendarBar(props: CalendarBarProps) {
    const { schedulingAssistantHeader, calendarColorScheme, buttonProps, ...divProps } = props;
    const calendarColorStyle = colorSchemeToCss(calendarColorScheme);
    const isBarExp =
        isHostAppFeatureEnabled('reduceCalBarExp') && isFeatureEnabled('cal-mf-reduceCalendarBar');
    return (
        <div
            {...divProps}
            style={{ backgroundColor: calendarColorStyle.backgroundColor }}
            className={classNames(styles.calendarBar, divProps.className, {
                [styles.calendarBarExp]: isBarExp,
            })}>
            {!isBarExp && (
                <>
                    {schedulingAssistantHeader && (
                        <span
                            style={{ color: calendarColorStyle.color }}
                            className={styles.calendarBarText}>
                            {schedulingAssistantHeader}
                        </span>
                    )}
                    <span className={styles.calendarBarFiller} />
                    {buttonProps &&
                        buttonProps.map(button => (
                            <IconButton
                                {...button}
                                key={button.iconProps!.iconName}
                                className={classNames(styles.calendarBarIcon, button.className)}
                            />
                        ))}
                </>
            )}
        </div>
    );
});
export default CalendarBar;
